import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import styles from '../../../pages/LeadCapture/LeadCaptureList/LeadCaptureList.module.css'
import * as clientEventService from '../../../services/clientEventService'
// Font Awesome assets
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPencil, faCogs } from '@fortawesome/free-solid-svg-icons'
// image elements
const pencil = <FontAwesomeIcon icon={faPencil} />
const cog = <FontAwesomeIcon icon={faCogs} />
const LCEvent = ({ index, eventItem, editEvent }) => {
    const navigate = useNavigate()
    const [clientEventInfo, setClientEventInfo] = useState({})
    const changeDateFormat = dateStr => {
        const parsedDate = Date.parse(dateStr)
        const date = new Date(parsedDate)
        const options = { weekday: 'short', year: 'numeric', month: 'numeric', day: 'numeric' };
        const dateFormatted = date.toLocaleDateString('en-us', options);
        const returnDate = dateFormatted.split(' ').slice(1).join('/')
        return returnDate
    }
    const navigateAndStoreEvent = e => {
        e.preventDefault()
        let datatoPass = {};
        if (eventItem.client && eventItem.id) {
            // save to localstorage
            datatoPass = {
                clientId: eventItem.client.clientId,
                eventId: clientEventInfo ? clientEventInfo.eventId : null,
                clientName: eventItem.client.clientName,
                eventName: clientEventInfo ? clientEventInfo.name : null,
                leadCaptureId: eventItem.id,
                leadCaptureName: eventItem.overwriteName,
            }
            clientEventService.setClientEvent(datatoPass)
        }
      
        navigate(`/LeadCaptureSetting/${eventItem.id}`, { state: datatoPass });
    }
    useEffect(() => {
        // check if entry is stored
        // store into local object
        let localclientevent = clientEventService.getClientEvent()
        if (localclientevent) {
            setClientEventInfo(localclientevent)
           
        }
    }, [])
    return (
        <>
            <tr className={styles.trAccounts}>
                <td className={styles.tdEvents}> {eventItem.refNumber}</td>
                <td className={styles.tdEvents}> {eventItem.overwriteName}</td>
                <td className={styles.tdEvents}> {eventItem.client.clientName}</td>
                <td className={styles.tdEvents}> {eventItem.eventName && eventItem.eventName !== undefined ? eventItem.eventName : "not configured"}</td>
                <td className={styles.tdEvents}> {eventItem.eventName2 && eventItem.eventName2 !== undefined ? eventItem.eventName2 : "not configured"}</td>
                <td className={styles.tdEvents}> {eventItem.eventName3 && eventItem.eventName3 !== undefined ? eventItem.eventName3 : "not configured"}</td>
                <td className={styles.tdEvents}> {eventItem.eventName4 && eventItem.eventName4 !== undefined ? eventItem.eventName4 : "not configured"}</td>
                <td className={styles.tdEvents}> {changeDateFormat(eventItem.earlyRegistrationDeadline)}</td>
                <td className={styles.tdEvents}> {changeDateFormat(eventItem.eventStartDate)}</td>
                <td className={styles.tdEvents}> {eventItem.testEvent && eventItem.testEvent !== undefined && eventItem.testEvent === true ? 'Yes' : 'No'}</td>
                <td className={styles.tdEvents}>
                    <button className={styles.editButton} onClick={e => editEvent(e)} id={eventItem.id} title="Edit lead capture.">
                        <i className={styles.buttonImage}>{pencil}</i>
                    </button>
                    <button className={styles.editButton} style={{marginLeft: '12px'} }
                        onClick={e => navigateAndStoreEvent(e)} id={eventItem.id} title={eventItem.overwriteName + " settings."}>
                        <i className={styles.buttonImage}>{cog}</i>
                    </button>
                </td>
            </tr>
            
        </>
    );
}

export default LCEvent;